// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/CIUDAD_ENCANTADA_CONTACTO_BACKGROUND_FORMULARIO.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: none;
}

.popup-content {
  background: linear-gradient(to right, #bc4f53, #b3282d) no-repeat center center fixed;
  border-radius: 5px;
  max-width: 1395px;
  width: 96.8%;
  min-height: 556px;
  display: flex;
  justify-content: center;
  text-align: center;
  position: relative;
  z-index: 10000;
  pointer-events: auto;
  overflow-y: auto;
}

.popup-content > div {
  padding: 20px;
  margin: 0%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: bottom right;
  background-repeat: no-repeat;
  position: relative;
  z-index: 10000;
  pointer-events: auto;
  overflow-y: hidden;
}

.displaynoneemailmovil {
  display: none;
}

.popup-content-items {
  width: 80%;
  max-width: 1109px;
}

.popup-content .cerrar {
  background: none;
  color: #ffffff;
  font-size: 50px;
  font-weight: 500;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  z-index: 99999;
  position: absolute;
  top: 15px;
  right: 20px;
}
@media (max-width: 630px) {
  .popup-content .cerrar {
    top: 0px;
    right: 10px;
  }
}

.popup-content .btn {
  background-color: #333;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.popup-content-items .gridgaptext {
  grid-gap: 7%;
}

.popup-content-items .gridgapnumber {
  grid-gap: 7.5%;
}

/* Estilos para el formulario */
.popup-content-items form {
  width: 100%;
  max-width: 100%;
  margin: 0px auto;
}

.popup-content-items input[type=text],
input[type=number],
input[type=email] {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  padding: 15px 0 15px 15px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  -webkit-text-fill-color: #cccccc;
}

textarea {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 15px 0 0px 15px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  font-size: 16px;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  -webkit-text-fill-color: #cccccc;
}

.popup-content-items label {
  display: block;
  text-align: left;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  margin-bottom: 11px;
  margin-top: 11px;
  font-weight: bold;
  color: wheat;
}

.popup-content-items input[type=submit] {
  background-color: #129b46;
  color: #fff;
  border: none;
  padding: 12px;
  font-size: 22px;
  font-family: "Montserrat", sans-serif;
  width: 100%;
  max-width: 100%;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup-content-items input[type=submit]:hover {
  background-color: rgba(18, 155, 71, 0.9176470588);
  transform: translateX(5px);
}

.conexiones :hover {
  cursor: pointer;
  transform: translateY(3px);
}

/* Estilos para mensajes de error */
.error {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

@media screen and (max-width: 500px) and (min-width: 100px) {
  .popup-content {
    background: linear-gradient(to right, #bc4f53, #b3282d) no-repeat center center fixed;
    border-radius: 5px;
    max-width: 1395px;
    width: 96.8%;
    min-height: 356px;
    display: flex;
    justify-content: center;
    text-align: center;
    position: relative;
    z-index: 10000;
    pointer-events: auto;
    overflow-y: auto;
  }
  .displaynoneemail {
    display: none;
  }
  .displaynoneemailmovil {
    display: inline-block;
    width: 100%;
  }
  .popup-content-items {
    width: 90%;
  }
  .popup-content-items input[type=text],
  input[type=number],
  input[type=email] {
    padding: 5px 0 5px 8px;
    font-size: 14px;
  }
  textarea {
    padding: 5px 0 0px 8px;
    font-size: 14px;
  }
  .popup-content-items label {
    display: block;
    text-align: left;
    font-size: 14px;
    font-family: "Montserrat", sans-serif;
    margin-bottom: 8px;
    margin-top: 8px;
    font-weight: bold;
    color: wheat;
  }
  .popup-content-items input[type=submit] {
    background-color: #129b46;
    color: #fff;
    border: none;
    padding: 10px;
    font-size: 18px;
    font-family: "Montserrat", sans-serif;
    width: 100%;
    max-width: 100%;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media screen and (max-width: 1000px) and (min-width: 500px) {
  .displaynoneemailmovil {
    display: none;
  }
  .conexionesgridgap {
    grid-gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/FormularioContacto/FormContacto.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AADF;;AAKA;EACE,qFAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yDAAA;EACA,iCAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,UAAA;EACA,iBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAFF;AAIE;EAbF;IAcI,QAAA;IACA,WAAA;EADF;AACF;;AAIA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA,+BAAA;AACA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AADF;;AAIA;;;EAGE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,gCAAA;AAFF;;AAKA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,gCAAA;AAHF;;AAMA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAHF;;AAMA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,qCAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,iDAAA;EACA,0BAAA;AAHF;;AAMA;EACE,eAAA;EACA,0BAAA;AAHF;;AAMA,mCAAA;AACA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AAHF;;AAMA;EACE;IACE,qFAAA;IACA,kBAAA;IACA,iBAAA;IACA,YAAA;IACA,iBAAA;IACA,aAAA;IACA,uBAAA;IACA,kBAAA;IACA,kBAAA;IACA,cAAA;IACA,oBAAA;IACA,gBAAA;EAHF;EAMA;IACE,aAAA;EAJF;EAOA;IACE,qBAAA;IACA,WAAA;EALF;EAQA;IACE,UAAA;EANF;EASA;;;IAGE,sBAAA;IACA,eAAA;EAPF;EAUA;IACE,sBAAA;IACA,eAAA;EARF;EAWA;IACE,cAAA;IACA,gBAAA;IACA,eAAA;IACA,qCAAA;IACA,kBAAA;IACA,eAAA;IACA,iBAAA;IACA,YAAA;EATF;EAYA;IACE,yBAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,eAAA;IACA,qCAAA;IACA,WAAA;IACA,eAAA;IACA,kBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAVF;AACF;AAaA;EACE;IACE,aAAA;EAXF;EAcA;IACE,cAAA;EAZF;AACF","sourcesContent":["@import \"~/src/utils/scss/index.scss\";\n\n.popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  pointer-events: none;\n}\n\n// #dedede\n.popup-content {\n  background: linear-gradient(to right, $color_formulario_1, $color_formulario_2) no-repeat center center fixed; // #bc4f53, #b3282d) no-repeat center center fixed;\n  border-radius: 5px;\n  max-width: 1395px;\n  width: 96.8%;\n  min-height: 556px;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  position: relative;\n  z-index: 10000;\n  pointer-events: auto;\n  overflow-y: auto;\n}\n\n.popup-content>div {\n  padding: 20px;\n  margin: 0%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  background-image: url($Form_Contacto);\n  background-position: bottom right;\n  background-repeat: no-repeat;\n  position: relative;\n  z-index: 10000;\n  pointer-events: auto;\n  overflow-y: hidden;\n}\n\n.displaynoneemailmovil {\n  display: none;\n}\n\n.popup-content-items {\n  width: 80%;\n  max-width: 1109px;\n}\n\n.popup-content .cerrar {\n  background: none;\n  color: #ffffff;\n  font-size: 50px;\n  font-weight: 500;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  z-index: 99999;\n  position: absolute;\n  top: 15px;\n  right: 20px;\n\n  @media (max-width: 630px) {\n    top: 0px;\n    right: 10px;\n  }\n}\n\n.popup-content .btn {\n  background-color: #333;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.popup-content-items .gridgaptext {\n  grid-gap: 7%;\n}\n\n.popup-content-items .gridgapnumber {\n  grid-gap: 7.5%;\n}\n\n/* Estilos para el formulario */\n.popup-content-items form {\n  width: 100%;\n  max-width: 100%;\n  margin: 0px auto;\n}\n\n.popup-content-items input[type=\"text\"],\ninput[type=\"number\"],\ninput[type=\"email\"] {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  max-width: 100%;\n  padding: 15px 0 15px 15px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n\n  font-size: 16px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 500;\n  -webkit-text-fill-color: #cccccc;\n}\n\ntextarea {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 15px 0 0px 15px;\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n\n  font-size: 16px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 500;\n  -webkit-text-fill-color: #cccccc; // color gris texto \n}\n\n.popup-content-items label {\n  display: block;\n  text-align: left;\n  font-size: 16px;\n  font-family: \"Montserrat\", sans-serif;\n  margin-bottom: 11px;\n  margin-top: 11px;\n  font-weight: bold;\n  color: wheat;\n}\n\n.popup-content-items input[type=\"submit\"] {\n  background-color: #129b46;\n  color: #fff;\n  border: none;\n  padding: 12px;\n  font-size: 22px;\n  font-family: \"Montserrat\", sans-serif;\n  width: 100%;\n  max-width: 100%;\n  text-align: center;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.popup-content-items input[type=\"submit\"]:hover {\n  background-color: #129b47ea;\n  transform: translateX(5px);\n}\n\n.conexiones :hover {\n  cursor: pointer;\n  transform: translateY(3px);\n}\n\n/* Estilos para mensajes de error */\n.error {\n  color: red;\n  font-size: 12px;\n  margin-top: 5px;\n}\n\n@media screen and (max-width: 500px) and (min-width: 100px) {\n  .popup-content {\n    background: linear-gradient(to right, $color_formulario_1, $color_formulario_2) no-repeat center center fixed; // #bc4f53, #b3282d) no-repeat center center fixed;\n    border-radius: 5px;\n    max-width: 1395px;\n    width: 96.8%;\n    min-height: 356px;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    position: relative;\n    z-index: 10000;\n    pointer-events: auto;\n    overflow-y: auto;\n  }\n\n  .displaynoneemail {\n    display: none;\n  }\n\n  .displaynoneemailmovil {\n    display: inline-block;\n    width: 100%;\n  }\n\n  .popup-content-items {\n    width: 90%;\n  }\n\n  .popup-content-items input[type=\"text\"],\n  input[type=\"number\"],\n  input[type=\"email\"] {\n    padding: 5px 0 5px 8px;\n    font-size: 14px;\n  }\n\n  textarea {\n    padding: 5px 0 0px 8px;\n    font-size: 14px;\n  }\n\n  .popup-content-items label {\n    display: block;\n    text-align: left;\n    font-size: 14px;\n    font-family: \"Montserrat\", sans-serif;\n    margin-bottom: 8px;\n    margin-top: 8px;\n    font-weight: bold;\n    color: wheat;\n  }\n\n  .popup-content-items input[type=\"submit\"] {\n    background-color: #129b46;\n    color: #fff;\n    border: none;\n    padding: 10px;\n    font-size: 18px;\n    font-family: \"Montserrat\", sans-serif;\n    width: 100%;\n    max-width: 100%;\n    text-align: center;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n@media screen and (max-width: 1000px) and (min-width: 500px) {\n  .displaynoneemailmovil {\n    display: none;\n  }\n\n  .conexionesgridgap {\n    grid-gap: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
